"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _FormInputs = _interopRequireDefault(require("./FormInputs"));

var _WithBackgroundImage = _interopRequireDefault(require("../../../darkmatter/WithBackgroundImage/WithBackgroundImage"));

var _closebtn = _interopRequireDefault(require("../assets/closebtn.png"));

var _closebtnDark = _interopRequireDefault(require("../assets/closebtnDark.png"));

var Form = function Form(props) {
  var closeEmailCapture = props.closeEmailCapture,
      type = props.type,
      image = props.image,
      darkCloseBtn = props.darkCloseBtn;
  var displayCloseBtn = type !== 'inline';

  if (image && image.url) {
    if (image.placement === 'background') {
      return /*#__PURE__*/_react["default"].createElement(_WithBackgroundImage["default"], {
        image: image.url
      }, /*#__PURE__*/_react["default"].createElement(_FormInputs["default"], props));
    }

    if (image.placement === 'left') {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "emailcapture-withimage-horizontal"
      }, /*#__PURE__*/_react["default"].createElement(_WithBackgroundImage["default"], {
        image: image.url
      }, /*#__PURE__*/_react["default"].createElement("div", null)), /*#__PURE__*/_react["default"].createElement(_FormInputs["default"], props));
    }

    if (image.placement === 'right') {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "emailcapture-withimage-horizontal"
      }, /*#__PURE__*/_react["default"].createElement(_FormInputs["default"], props), /*#__PURE__*/_react["default"].createElement(_WithBackgroundImage["default"], {
        image: image.url
      }, /*#__PURE__*/_react["default"].createElement("div", null, displayCloseBtn && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Image, {
        as: "a",
        id: "closeEmailCapture",
        src: darkCloseBtn ? _closebtnDark["default"] : _closebtn["default"],
        onClick: function onClick() {
          return closeEmailCapture(true);
        }
      }))));
    }

    if (image.placement === 'top') {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "emailcapture-withimage-vertical"
      }, /*#__PURE__*/_react["default"].createElement(_WithBackgroundImage["default"], {
        image: image.url
      }, /*#__PURE__*/_react["default"].createElement("div", null, displayCloseBtn && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Image, {
        as: "a",
        id: "closeEmailCapture",
        src: darkCloseBtn ? _closebtnDark["default"] : _closebtn["default"],
        onClick: function onClick() {
          return closeEmailCapture(true);
        }
      }))), /*#__PURE__*/_react["default"].createElement(_FormInputs["default"], props));
    }
  }

  return /*#__PURE__*/_react["default"].createElement(_FormInputs["default"], props);
};

var _default = Form;
exports["default"] = _default;